module.exports = __webpack_public_path__ + "assets/img/gar8-6.446f0cca.jpg";